import React from 'react';
import PropTypes from 'prop-types';
import MainGridMiddleLeftRowDayOnTypeSlot from './MainGridMiddleLeftRowDayOnTypeSlot';

/**
 * MainGridMiddleLeftDayOnTypeSlot
 */
class MainGridMiddleLeftDayOnTypeSlot extends React.Component {

  render() {
    const toK015Param = this.props.toK015Param;
    const titledata = this.props.dataDayOn.filter((item) => {
      return (item.daytype == '期間');
    });
    const MainGridNodes = titledata.map((maingrid, index) => {
      return (
        <MainGridMiddleLeftRowDayOnTypeSlot dataDayOnItem={maingrid} toK015Param={toK015Param} key={index} index={index} />
      );
    });

    return (
      <div className="ledger_sheet_scroll return_y fixed_width ib vt bar bar_xy bar_y_hidden fixed_left" onScroll={e => this.props.actions.onScroll(e.target)}>
        <div className="ledger_sheet_scroll_inner max_height_target max_height_day">
          <div className="modlue left_col textleft border_b">
            {MainGridNodes}
          </div>
        </div>
      </div>
    );
  }
}

MainGridMiddleLeftDayOnTypeSlot.propTypes = {
  dataDayOn: PropTypes.any.isRequired,
  toK015Param: PropTypes.any.isRequired,
};

export default MainGridMiddleLeftDayOnTypeSlot;
